import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { UtilitiesModule } from 'src/app/utilities/utilities.module';
import { CoreModule } from 'src/app/core/core.module';
import { CategoryListingComponent } from './components/category-listing/category-listing.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { VideoCaraouselComponent } from './components/video-caraousel/video-caraousel.component';
import { MainPageComponent } from './pages/main-page/main-page.component';
import { SidebarModule } from 'primeng/sidebar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { ReturnPolicyComponent } from './pages/return-policy/return-policy.component';
import { ShippingPolicyComponent } from './pages/shipping-policy/shipping-policy.component';
import { TermsServiceComponent } from './pages/terms-service/terms-service.component';
import { FaqsComponent } from './pages/faqs/faqs.component';
import { CarouselModule } from 'primeng/carousel';
import { ShoppingModule } from '../shopping/shopping.module';
import { TrackingComponent } from './pages/tracking/tracking.component';

@NgModule({
  declarations: [
    HomeComponent,
    CategoryListingComponent,
    FeedbackComponent,
    MainPageComponent,
    ContactUsComponent,
    AboutUsComponent,
    PrivacyPolicyComponent,
    ReturnPolicyComponent,
    ShippingPolicyComponent,
    TermsServiceComponent,
    FaqsComponent,
    TrackingComponent,
  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    SidebarModule,
    ProgressSpinnerModule,
    VideoCaraouselComponent,
    CarouselModule,
    UtilitiesModule,
    ShoppingModule
  ],
  exports: [FeedbackComponent],
})
export class DashboardModule {}
